// 按下就有回應（2026-09-25 動態設計 P4）：滑過、聚焦、手指碰到站內連結時先載那一頁的程式與內文；
// 畫面裡看得到的站內連結（手機以作品卡為主）也先載，最多 24 條。
// 舊版點下去要先等 lazy chunk（140–310ms）才開始任何變化；預載後導航一開始轉場就能開始。
import { preloadRouteContent } from './content-preload'
import { isBot } from './view-transition'

const seen = new Set()
let observer = null

function prefetch(router, href) {
  let url
  try { url = new URL(href, location.href) } catch { return }
  if (url.origin !== location.origin || seen.has(url.pathname)) return
  seen.add(url.pathname)
  let route
  try { route = router.resolve(url.pathname) } catch { return }
  for (const record of route.matched) {
    for (const component of Object.values(record.components || {})) {
      if (typeof component === 'function') {
        try { Promise.resolve(component()).catch(() => seen.delete(url.pathname)) } catch {}
      }
    }
  }
  preloadRouteContent(route)
}

const linkOf = target => target?.closest?.('a[href]')
const internal = a => a && !a.target && !a.hasAttribute('download') && a.getAttribute('href')?.startsWith('/')

export function installPrefetch(router) {
  if (typeof document === 'undefined' || isBot()) return   // 預渲染與爬蟲不預載
  const onIntent = event => { const a = linkOf(event.target); if (internal(a)) prefetch(router, a.href) }
  document.addEventListener('pointerover', onIntent, { passive: true })
  document.addEventListener('focusin', onIntent)
  document.addEventListener('touchstart', onIntent, { passive: true })
  if (typeof IntersectionObserver === 'function' && !navigator.connection?.saveData) {
    observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue
        observer.unobserve(entry.target)
        prefetch(router, entry.target.href)
      }
    }, { rootMargin: '0px 0px 200px 0px' })
  }
}

// 新頁掛載後呼叫：觀察主內容裡的站內連結
export function observeVisibleLinks(root) {
  if (!observer || !root?.querySelectorAll) return
  const links = [...root.querySelectorAll('a[href^="/"]')].filter(a => !seen.has(new URL(a.href).pathname)).slice(0, 24)
  const idle = window.requestIdleCallback || (cb => setTimeout(cb, 300))
  idle(() => links.forEach(a => a.isConnected && observer.observe(a)))
}
